import { useUsersMeRetrieve } from '@api'
import { Group } from '@api/models'
// import { Group, Users } from '@api/models'

export type ResourceType =
  | 'DASHBOARD'
  | 'QUOTE_REQUEST'
  | 'PURCHASE'
  | 'SELLING'
  | 'SCHEDULE'
  | 'BOOKING'
  | 'SHIPMENT'
  | 'SHIPMENT_STATUS'
  | 'SHIPMENT_BACKLOG'
  | 'BILLING'
  | 'BILLING_INFO'
  | 'DEBIT_NOTE_CREDIT_NOTE'
  | 'DEPOSIT_REPORT'
  | 'ACCOUNTING_REPORT'
  | 'NETWORK'
  | 'TRUCK_CARRIERS'
  | 'USER_COMPANY'
  | 'USER_COMPANY_INFO'
  | 'VESSEL'
  | 'COMMODITY'
  | 'MILESTONE'
  | 'GUEST'
  | 'CHAT'
  | 'DOCUMENT'
  | 'LAND_TRANSPORT'
  | 'CUSTOM'
  | 'TRADE_DOCUMENTS' // A/NやS/Iなどの貿易書類
  | 'TRADE_DOCUMENTS_PDF' // 貿易書類のPDF
  | 'QUOTES'
  | 'CONTAINER_TRACKING'
  | 'AIR_FLIGHT_NUMBER'
  | 'AIR_TRANSPORT_SCHEDULE'
  | 'BOOKMARK'
  | 'SHIPPING' // shipment一覧の船舶情報の表示・非表示
  | 'FORWARDER_GUEST'
  | 'PAY_STATUS'
  | 'PRICE_MANAGEMENT'
  | 'SWITCH_USER' // アカウント切替
  | 'DELIVERY_REQUEST' // ユーザー側の配送情報の追加、更新

export type Operation = 'CREATE' | 'READ' | 'UPDATE'

type UserRole =
  | 'USER' /** @deprecated - use 'CUSTOMER' instead */
  | 'FORWARDER'
  | 'GUEST'
  | 'PORTRICH'
  | 'PORTRICH PARTNER'
  | 'CUSTOMER'

export type WithResourceType<T> = T & {
  resourceType: ResourceType
}

const permissions: {
  [r in ResourceType]: { [o in Operation]?: UserRole[] }
} = {
  DASHBOARD: {
    READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER', 'GUEST'],
  },
  QUOTE_REQUEST: { READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'] },
  PURCHASE: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  SELLING: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  QUOTES: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  SCHEDULE: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  BOOKING: {
    READ: [
      'USER',
      'CUSTOMER',
      'PORTRICH',
      'PORTRICH PARTNER',
      'GUEST',
      'FORWARDER',
    ],
    CREATE: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  SHIPMENT: {
    READ: [
      'USER',
      'CUSTOMER',
      'PORTRICH',
      'PORTRICH PARTNER',
      'GUEST',
      'FORWARDER',
    ],
    UPDATE: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'],
  },
  SHIPMENT_STATUS: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  SHIPMENT_BACKLOG: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  BILLING: { READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'] },
  BILLING_INFO: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  DEBIT_NOTE_CREDIT_NOTE: { READ: ['PORTRICH'] }, // TODO: Portrich Partner に付与する前に PaymentInvoicePrice の買値の値の取扱いについて調整する.
  DEPOSIT_REPORT: { CREATE: ['PORTRICH'] },
  ACCOUNTING_REPORT: { READ: ['PORTRICH'] },
  NETWORK: { READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'] },
  TRUCK_CARRIERS: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  USER_COMPANY: {
    READ: ['PORTRICH', 'PORTRICH PARTNER', 'FORWARDER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  USER_COMPANY_INFO: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  VESSEL: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  COMMODITY: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  MILESTONE: { READ: ['PORTRICH', 'PORTRICH PARTNER'] },
  GUEST: { READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'] },
  CHAT: {
    READ: [
      'USER',
      'CUSTOMER',
      'PORTRICH',
      'PORTRICH PARTNER',
      'GUEST',
      'FORWARDER',
    ],
  },
  DOCUMENT: {
    READ: [
      'USER',
      'CUSTOMER',
      'PORTRICH',
      'PORTRICH PARTNER',
      'GUEST',
      'FORWARDER',
    ],
  },
  LAND_TRANSPORT: {
    READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'],
  },
  CUSTOM: { READ: ['USER', 'CUSTOMER', 'PORTRICH', 'PORTRICH PARTNER'] },
  TRADE_DOCUMENTS: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  TRADE_DOCUMENTS_PDF: {
    READ: ['PORTRICH'],
    CREATE: ['PORTRICH'],
    UPDATE: ['PORTRICH'],
  },
  CONTAINER_TRACKING: {
    READ: [
      'PORTRICH',
      'PORTRICH PARTNER',
      'FORWARDER',
      'USER',
      'CUSTOMER',
      'GUEST',
    ],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER', 'FORWARDER'],
  },
  AIR_FLIGHT_NUMBER: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  AIR_TRANSPORT_SCHEDULE: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  BOOKMARK: { READ: ['USER', 'CUSTOMER'] },
  SHIPPING: { READ: ['FORWARDER', 'PORTRICH', 'PORTRICH PARTNER'] },
  FORWARDER_GUEST: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH'],
  },
  PAY_STATUS: { READ: ['PORTRICH', 'PORTRICH PARTNER', 'CUSTOMER'] },
  PRICE_MANAGEMENT: {
    READ: ['PORTRICH', 'PORTRICH PARTNER'],
    CREATE: ['PORTRICH', 'PORTRICH PARTNER'],
    UPDATE: ['PORTRICH', 'PORTRICH PARTNER'],
  },
  SWITCH_USER: { READ: ['PORTRICH'] },
  DELIVERY_REQUEST: {
    READ: ['CUSTOMER'],
    CREATE: ['CUSTOMER'],
  },
}

// /** @deprecated */
// function hasFunctionPermissionDeprecated(
//   role: UserRole,
//   resourceType: ResourceType,
//   operation: Operation = 'READ',
// ) {
//   return permissions[resourceType][operation]?.includes(role)
// }

const hasFunctionPermission = (
  groups: Group[],
  resourceType: ResourceType,
  operation: Operation = 'READ',
) => {
  const result = groups.some((group) =>
    permissions[resourceType][operation]?.some(
      (expected) => expected === group.name.toUpperCase(),
    ),
  )
  // TODO: 権限周りの確認が終わったら削除する.
  // if (!result) {
  //   console.log(`🔍 Checking permission for ${resourceType}:${operation}`)
  //   console.log(
  //     '📋 User groups:',
  //     groups.map((g) => g.name),
  //   )
  //   console.log('✅ Required roles:', permissions[resourceType][operation])
  //   console.log('❌ Permission denied')
  // }
  return result
}

// /** @deprecated reference `user.groups` instead */
// function getUserRole(user: Users) {
//   if (user.is_portrich) return 'PORTRICH'
//   if (user.is_forwarder) return 'FORWARDER'
//   if (user.is_user) return 'USER'
//   if (user.is_guest) return 'GUEST'
//   return undefined
// }

export const usePermission = () => {
  const { data: user } = useUsersMeRetrieve()
  // const role = user ? getUserRole(user) : undefined

  // const permitted = (resourceType: ResourceType, operation: Operation) =>
  //   hasFunctionPermission(user?.groups || [], resourceType, operation) ||
  //   (role && hasFunctionPermissionDeprecated(role, resourceType, operation))

  const permitted = (resourceType: ResourceType, operation: Operation) =>
    hasFunctionPermission(user?.groups || [], resourceType, operation)

  const filter = <T>(items: WithResourceType<T>[]): T[] =>
    items
      .filter((item) => permitted(item.resourceType, 'READ'))
      .map((item) => {
        const { resourceType, ...origin } = item
        return origin as T
      })

  return { permitted, filter }
}
